<template>
  <div class="custom-table">
    <!-- 表头 -->
    <van-row class="table-header" type="flex">
        <van-col span="8">类型</van-col>
        <van-col span="8">金额</van-col>
        <van-col span="8">时间</van-col>
    </van-row>

    <!-- 数据行 -->
    <van-row
        v-for="(item, index) in recordData"
        :key="index"
        class="table-row"
        type="flex"
      >
        <van-col span="8">{{ getType(item.type).label }}</van-col>
        <van-col span="8" :class="{redColor: getType(item.type).value === '-', greenColor: getType(item.type).value === '+'}">{{ getType(item.type).value }} {{ item.money }}</van-col>
        <van-col span="8">{{ item.created_at }}</van-col>
    </van-row>
    <van-row
        v-if="!recordData.length || recordData.length === 0"
        class="table-no-data"
    >
      <van-col span="24">暂无数据</van-col>
    </van-row>
    </div>
    <!-- 分页 -->
    <div class="custom-pagination">
        <div class="custom-pagination-left">
            <span>共{{ totalCount }}条数据</span>
            <span>当前在第{{ currentPage }}页</span>
        </div>
        <div class="custom-pagination-right">
            <div class="custom-pagination-right1">
                <div
                    class="pre"
                    :class="{ disabled: currentPage <= 1 }"
                    @click="changePage(-1)">
                    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.83705 0.805555C4.03227 0.61034 4.34881 0.610436 4.54408 0.805555L4.8976 1.15907C5.09286 1.35433 5.09286 1.67084 4.8976 1.8661L2.71693 4.04579L4.8351 6.16395C5.03036 6.35922 5.03036 6.67572 4.8351 6.87098L4.48158 7.2245C4.28631 7.41962 3.96977 7.41972 3.77455 7.2245L0.946426 4.39638C0.75121 4.20116 0.751302 3.88462 0.946426 3.68934L1.29994 3.33583C1.31198 3.3238 1.32611 3.31415 1.339 3.3036L3.83705 0.805555Z" fill="#A9A9A9"/>
                    </svg>
                </div>
                <div class="current">{{ currentPage }}</div>
                <div
                    @click="changePage(1)"
                    class="next"
                    :class="{ disabled: currentPage >= totalPage }"
                    >
                    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.16295 0.805555C1.96773 0.61034 1.65119 0.610436 1.45592 0.805555L1.1024 1.15907C0.90714 1.35433 0.90714 1.67084 1.1024 1.8661L3.28307 4.04579L1.1649 6.16395C0.96964 6.35922 0.96964 6.67572 1.1649 6.87098L1.51842 7.2245C1.71369 7.41962 2.03023 7.41972 2.22545 7.2245L5.05357 4.39638C5.24879 4.20116 5.2487 3.88462 5.05357 3.68934L4.70006 3.33583C4.68802 3.3238 4.67389 3.31415 4.661 3.3036L2.16295 0.805555Z" fill="#A9A9A9"/>
                    </svg>
                </div>
            </div>
            <div class="custom-pagination-right2" @click="showPageSizePopup = !showPageSizePopup">
                {{ pageSize }}条/页
            </div>
        </div>
    </div>
    <!-- 展示分页选择 -->
    <van-popup
        v-model:show="showPageSizePopup"
        position="bottom"
        :closeable="true"
        class="yueBao-pageSize-popup"
        >
        <div class="yueBao-pageSize-popup-title">选择每页条数</div>
        <van-row class="yueBao-pageSize-popup-select" type="flex">
            <van-col
                v-for="(item, index) in pageSizeOptions"
                :key="index"
                :value="item.text"
                :center="true"
                :class="{ 'yueBao-pageSize-popup-item-active': item.value === pageSize }"
                @click="changePageSize(item.value)"
                span="24"
            >
                {{ item.text }}
            </van-col>
        </van-row>
    </van-popup>
    <!-- 展示日期选择 -->
    <van-popup
        v-model:show="showPageSizePopup"
        position="bottom"
        :closeable="true"
        class="yueBao-pageSize-popup"
        >
        <div class="yueBao-pageSize-popup-title">页码选择</div>
        <van-row class="yueBao-pageSize-popup-select" type="flex">
            <van-col
                v-for="(item, index) in pageSizeOptions"
                :key="index"
                :value="item.text"
                :center="true"
                :class="{ 'yueBao-pageSize-popup-item-active': item.value === pageSize }"
                @click="changePageSize(item.value)"
                span="24"
            >
                {{ item.text }}
            </van-col>
        </van-row>
    </van-popup>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  // 传入的表格数据
  recordData: {
    type: Array,
    default: () => []
  },
  currentPage: {
    type: Number,
    default: 1
  },
  pageSize: {
    type: Number,
    default: 5
  },
  totalPage: {
    type: Number,
    default: 0
  },
  totalCount: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(['update:currentPage', 'update:pageSize'])

const currentPage = ref(props.currentPage)
const pageSize = ref(props.pageSize)
const showPageSizePopup = ref(false)

watch(() => props.currentPage, (newVal) => {
  currentPage.value = newVal
})

const getType = (type) => {
  switch (type * 1) {
    case 1:
      return {
        label: '系统转出',
        value: '-'
      }
    case 2:
      return {
        label: '收益',
        value: '+'
      }
    case 3:
      return {
        label: '转出',
        value: '-'
      }
    case 4:
      return {
        label: '转入',
        value: '+'
      }
    default:
      return {
        label: '系统转出',
        value: '-'
      }
  }
}

const pageSizeOptions = [
    { text: '5条/页', value: 5 },
    { text: '10条/页', value: 10 }
]
// 监听当前页变化
const changePageSize = (size) => {
  if (size !== props.pageSize) {
    pageSize.value = size
    currentPage.value = 1
    showPageSizePopup.value = false
    // 更新父组件的 pageSize
    emit('update:pageSize', size)
  }
}

// 监听每页条数变化
const changePage = (direction) => {
  if (direction === -1 && currentPage.value > 1) {
    currentPage.value -= 1
  } else if (direction === 1 && currentPage.value < props.totalPage) {
    currentPage.value += 1
  }
  emit('update:currentPage', currentPage.value)
}
</script>

<style scoped lang="less">
.custom-table {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #7DC3FA;
  border-radius: 8px;
  .table-header {
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        text-align: center;
        background: #D5EEFC;
        height: 26px;
        line-height: 26px;
        :deep(.van-col) {
            height: 26px;
            border-right: 1px solid #7DC3FA;
            border-bottom: 1px solid #7DC3FA;
            &:last-child {
                border-right: none;
            }
        }
  }
   
  .table-row {
        text-align: center;
        height: 26px;
        line-height: 26px;
        :deep(.van-col) {
            height: 26px;
            font-size: 10px;
            font-weight: 500;
            border-right: 1px solid #7DC3FA;
            border-bottom: 1px solid #7DC3FA;
            &:last-child {
                border-right: none;
            }
            &.redColor {
                color: #F56C6C;
            }
            &.greenColor {
                color: #67C23A;
            }
        }
        &:nth-last-child(1) {
            :deep(.van-col) {
                border-bottom: none;
            }
        }
  }
  .table-no-data {
    height: 48px;
    text-align: center;
    :deep(.van-col) {
        height: 48px;
        line-height: 48px;
    }
  }
}
.custom-pagination {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      background-color: #fff;
      .custom-pagination-left {
          font-size: 12px;
          color: #00000099;
          span:nth-child(2) {
              color: #3080D3;
          }
      }
      .custom-pagination-right {
          display: flex;
          align-items: center;
          .custom-pagination-right1 {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #00000099;
              div {
                width: 20px;
                height: 20px;
                line-height: 20px;
                border-radius: 2px;
                border: 1px solid #D5D5D5;
                background-color: #fff;
                margin-right: 5px;
                color: #4E5969;
                text-align: center;
                svg {
                    width: 12px;
                    height: 12px;
                }
                &.disabled {
                    background-color: #D5D5D5;
                    pointer-events: none;
                }
              }
              .current {
                border: 1px solid #3080D3;
                color: #3080D3;
              }
          }
          .custom-pagination-right2 {
              height: 20px;
              padding: 0 10px;
              line-height: 20px;
              font-size: 12px;
              font-weight: 500;
              color: #3080D3;
              border: 1px solid #3080D3;
              border-radius: 2px;
          }
      }
  }
</style>
<style lang="less">
.yueBao-pageSize-popup {
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .yueBao-pageSize-popup-title {
    font-size: 16px;
    font-weight: bold;
    color: #00000099;
    text-align: center;
    padding: 10px 0;
  }
  .yueBao-pageSize-popup-select {
    background-color: #fff;
    border-radius: 8px;
    padding: 10px 0;
    .van-col {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #00000099;
      text-align: center;
      border-bottom: 1px solid #E5E5E5;
      &:hover {
        background-color: #F8F8F8;
        cursor: pointer;
      }
      &:last-child {
        border-bottom: none;
      }
      &.yueBao-pageSize-popup-item-active {
        background-color: #3080D3;
        color: #fff;
       }
    }
  }
 
}
</style>